/*
 * description: iframe通信 【子页面】
 * */

import { message as $message } from 'antd'

const isTopWidow = window.self === window.top

const getTargetWindow = () => {
  for (let i = 0; i < window.parent.frames.length; i++) {
    const win = window.parent.frames[i]
    if (win === window) {
      return win
    }
  }

  return null
}

export const createMessageChannel = ({ origin }: any) => {
  const _eventMap = new Map()

  const _handler = (e: any) => {
    if (origin && origin !== '*' && e.origin !== origin) return

    const win = getTargetWindow()

    const { eventName, eventData, namespace: _namespace } = e.data || {}

    // 命名空间是否一致
    if (win && win.name && _namespace && _namespace === win.name) {
      if (_eventMap.has(eventName)) {
        _eventMap.get(eventName).forEach((fn: any) => fn(eventData, e))
      }
    }
  }

  const _attachEvent = (eventName: string, handler: any) => {
    if (_eventMap.has(eventName)) {
      const queue = _eventMap.get(eventName).filter((fn: any) => fn !== handler)

      queue.push(handler)

      _eventMap.set(eventName, queue)
    } else {
      _eventMap.set(eventName, [handler])
    }
  }

  // 接收消息
  const receiveMessage = (eventName: string, handler: any) => {
    _attachEvent(eventName, handler)
  }

  // 移除监听
  const removeListen = (eventName: string, handler: any) => {
    if (_eventMap.has(eventName)) {
      _eventMap.set(
        eventName,
        _eventMap.get(eventName).filter((fn: any) => fn !== handler)
      )
    }
  }

  // 发送消息至父窗口
  const postMessage = (eventName: string, eventData?: any) => {
    if (isTopWidow) {
      return
    }

    const win = getTargetWindow()

    window.parent.postMessage({ eventName, eventData, namespace: win && win.name }, origin)
  }

  window.addEventListener('message', _handler, false)

  const close = () => {
    window.removeEventListener('message', _handler, false)
    _eventMap.clear()
  }

  return {
    postMessage,
    receiveMessage,
    removeListen,
    close
  }
}

export const messageChannel = createMessageChannel({
  origin: '*'
})

export const message = (() => {
  if (isTopWidow) {
    return {
      success(content: string) {
        $message.success(content)
      },
      error(content: string) {
        $message.error(content)
      },
      loading(content: string, duration?: number) {
        return $message.loading(content, duration)
      }
    }
  }

  return {
    success(content: string, namespace = 'global') {
      messageChannel.postMessage(`${namespace}/message:success`, { content })
    },
    error(content: string, namespace = 'global') {
      messageChannel.postMessage(`${namespace}/message:error`, { content })
    },
    loading(content: string, duration?: number, namespace = 'global') {
      messageChannel.postMessage(`${namespace}/loading:show`, { content, duration })

      return () => messageChannel.postMessage(`${namespace}/loading:hide`)
    }
  }
})()
